import { confirmPasswordSchema, createPasswordSchema, emailSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const forgotPassSchema = object().shape({
  email: emailSchema,
  password: createPasswordSchema,
  confirm_password: confirmPasswordSchema(),
});

export default forgotPassSchema;